import React from "react";
import { useTranslation } from "react-i18next";

import { PositionHistoryTableRow } from "./positions-history-table-row";
import { useTableSort } from "@/hooks/use-table-sort/use-table-sort";
import { SortButton } from "@/pages/funds-list/components/funds-main/funds-table/sort-button";

export const PositionsHistoryTable = ({ data }) => {
  const { t } = useTranslation();
  const { order, sortBy, sortOptions, handleSort } = useTableSort();

  // todo: should in case of empty list.
  if (data.length) {
    return (
      <div className="p-10 flex flex-col items-center justify-center">
        <h2 className="text-xl font-semibold font-sf-pro text-gray-800 dark:text-white">
          Currently you don't have any open positions
        </h2>
        <h2 className="text-l font-sf-pro text-gray-800 dark:text-white mt-3">
          Start by making your first fund requests with your wallet
        </h2>
      </div>
    );
  }

  return (
    <table className="w-full mt-7">
      <thead>
        <tr className="relative">
          <th className="w-11"></th>
          <th className="text-s md:text-m bg-gradient-to-r from-white dark:from-gray-900 via-white dark:via-gray-900 to-opacity-0 md:bg-transparent h-full sticky -left-0.5 z-10 md:static font-sf-pro whitespace-nowrap text-gray-400 text-left font-semibold py-2 px-1 md:px-3">
            <SortButton
              onClick={() => handleSort(sortOptions.name)}
              name="sort-by-name"
              order={order}
              className="w-fit ml-auto"
              label={t("positions.historyTable.title.name")}
              showArrow={sortBy === sortOptions.name}
            />
          </th>
          <th></th>
          <th className="font-sf-pro text-s md:text-m whitespace-nowrap text-gray-400 font-semibold py-2 px-3 pl-7 pr-0 text-right">
            <SortButton
              onClick={() => handleSort(sortOptions.action)}
              name="sort-by-action"
              order={order}
              className="w-fit ml-auto"
              label={t("positions.historyTable.title.action")}
              showArrow={sortBy === sortOptions.action}
            />
          </th>
          <th className="font-sf-pro text-s md:text-m whitespace-nowrap text-gray-400 font-semibold py-2 px-3 pl-7 pr-0 text-right">
            <SortButton
              onClick={() => handleSort(sortOptions.quantity)}
              name="sort-by-quantity"
              order={order}
              className="w-fit ml-auto"
              label={t("positions.historyTable.title.quantity")}
              showArrow={sortBy === sortOptions.quantity}
            />
          </th>
          <th className="font-sf-pro text-s md:text-m whitespace-nowrap text-gray-400 font-semibold py-2 px-3 pr-0 text-right">
            <SortButton
              onClick={() => handleSort(sortOptions.date)}
              name="sort-by-date"
              order={order}
              className="w-fit ml-auto"
              label={t("positions.historyTable.title.date")}
              showArrow={sortBy === sortOptions.date}
            />
          </th>
          <th className="font-sf-pro text-s md:text-m whitespace-nowrap text-gray-400 font-semibold py-2 px-3 pr-0 text-right">
            <SortButton
              onClick={() => handleSort(sortOptions.fundFee)}
              name="sort-by-fee"
              order={order}
              className="w-fit ml-auto"
              label={t("positions.historyTable.title.fee")}
              showArrow={sortBy === sortOptions.fundFee}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((dataRow, index) => (
          <PositionHistoryTableRow key={index} dataRow={dataRow} />
        ))}
      </tbody>
    </table>
  );
};
